import { AuthStore } from 'auth';
import { AES, enc } from 'crypto-js';
import { ActingAsUserWithFeatures, UserWithFeatures } from 'types/auth/user-context.type';

const ACTING_AS_INTERMEDIARY_KEY = 'acting_as_intermediary';
const ACTING_AS_ENCRYPTION_KEY = 'JnrYe50bdUA7hY9k';

export const clearActingAsIntermediaryFromStorage = () => {
  sessionStorage.removeItem(ACTING_AS_INTERMEDIARY_KEY);
};

export const storeActingAsIntermediary = (user: UserWithFeatures | undefined): void => {
  const currentUser = AuthStore.getUserInfo();
  if (!user || !currentUser) {
    clearActingAsIntermediaryFromStorage();
    return;
  }
  const actingAsUser: ActingAsUserWithFeatures = {
    ...user,
    rootUser: currentUser.sub
  };
  const jsonStringUser = JSON.stringify(actingAsUser);
  const encryptedUser = AES.encrypt(jsonStringUser, ACTING_AS_ENCRYPTION_KEY).toString();
  window.sessionStorage.setItem(ACTING_AS_INTERMEDIARY_KEY, encryptedUser);
};

export const getActingAsIntermediaryFromStorage = (): UserWithFeatures | undefined => {
  const currentUser = AuthStore.getUserInfo();
  const userFromStorage = window.sessionStorage.getItem(ACTING_AS_INTERMEDIARY_KEY);
  if (!userFromStorage || !currentUser) return;
  const decryptedUser = AES.decrypt(userFromStorage, ACTING_AS_ENCRYPTION_KEY).toString(enc.Utf8);
  if (!decryptedUser) {
    clearActingAsIntermediaryFromStorage();
    return;
  }
  const user = JSON.parse(decryptedUser) as ActingAsUserWithFeatures;

  if (user.rootUser !== currentUser.sub) {
    clearActingAsIntermediaryFromStorage();
    return;
  }
  return user;
};

export const validateActingAsIntermediaryInStorage = (): void => {
  const currentUser = AuthStore.getUserInfo();
  const userFromStorage = window.sessionStorage.getItem(ACTING_AS_INTERMEDIARY_KEY);
  if (!userFromStorage || !currentUser) {
    clearActingAsIntermediaryFromStorage();
    return;
  }
  const decryptedUser = AES.decrypt(userFromStorage, ACTING_AS_ENCRYPTION_KEY).toString(enc.Utf8);
  if (!decryptedUser) {
    clearActingAsIntermediaryFromStorage();
    return;
  }
  const user = JSON.parse(decryptedUser) as ActingAsUserWithFeatures;

  if (user.rootUser !== currentUser.sub) {
    clearActingAsIntermediaryFromStorage();
    return;
  }
};
